/* eslint-disable import/no-default-export */
import { createReducer } from 'app/gamma/src/util/reducers';

import {
  LOAD_MY_BOARDS_ERROR,
  LOAD_MY_BOARDS_REQUEST,
  LOAD_MY_BOARDS_SUCCESS,
} from 'app/gamma/src/modules/loaders';

// Reducer
export interface BoardSelectorState {
  loading: boolean;
}

const initialState: BoardSelectorState = {
  loading: false,
};

export default createReducer(initialState, {
  [LOAD_MY_BOARDS_REQUEST](state: BoardSelectorState) {
    return {
      ...state,
      loading: true,
    };
  },

  [LOAD_MY_BOARDS_SUCCESS](state: BoardSelectorState) {
    return {
      ...state,
      loading: false,
    };
  },

  [LOAD_MY_BOARDS_ERROR](state: BoardSelectorState) {
    return {
      ...state,
      loading: false,
    };
  },
});
